export default __webpack_public_path__ + "static/media/shield_grey.49130c5e.svg";